export default __webpack_public_path__ + "static/media/fond-arrondi-blanc.7bddf711.webp";